import { Route } from '@angular/router';
import { isProductActiveGuard } from '../../../guards/is-product-active.guard';
import { roleGuard } from '../../../guards/role.guard';
import { Role } from '../../auth/model/role.model';

export const employeePerformanceRoute: Route = {
  path: 'my-performance',
  loadComponent: () => import('./employee-performance.component').then(m => m.EmployeePerformanceComponent),
  canActivate: [isProductActiveGuard('Performance'), roleGuard],
  data: { roles: ['Employee'] satisfies Role[], breadcrumb: 'Performance & Achievement' },
};
